import React from "react";

const VideoPreview = ({ src }) => {
  const isYouTube = src.includes("youtube.com") || src.includes("youtu.be");

  const getYouTubeEmbedUrl = (url) => {
    const match = url.match(/(?:\?v=|\.be\/|\/embed\/)([^&]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : url;
  };

  if (!src) return null;

  return isYouTube ? (
    <iframe
      title="Sample YouTube Video"
      width="100%"
      height="200"
      src={getYouTubeEmbedUrl(src)}
    ></iframe>
  ) : (
    <video src={src} controls style={{ width: "100%", maxHeight: 200 }} />
  );
};

export default VideoPreview;
